import React from 'react';
import { string } from 'prop-types';
import { Translate } from 'react-localize-redux';
import { SurveySchemaPartEditorType } from '../../../../constants/types';
import VariableFeedbackPreview from './variableFeedbackPreview';

import styles from './variableFeedbackPreview.module.css';

const SchemaPartFeedbackPreview = ({ schemaPart, previewLang }) => {
  const { variables } = schemaPart;
  return (
    <div>
      {
        variables.length > 0
          ? variables.map((v) =>
            <VariableFeedbackPreview key={v.order} previewLang={previewLang} variable={v} />)
          : (
            <div className={styles.infoText}>
              <p><Translate id="editor.surveySchemaPartPreview.noPreviewDimensions" /></p>
            </div>
          )
      }
    </div>
  );
};

SchemaPartFeedbackPreview.propTypes = {
  schemaPart: SurveySchemaPartEditorType.isRequired,
  previewLang: string.isRequired
};

export default SchemaPartFeedbackPreview;
